import { motion, AnimatePresence } from 'framer-motion';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';

const formatPrice = (price) =>
    Number(price).toLocaleString('fa-IR');

const InvoiceDetailSheet = ({ open, onClose, data }) => {
    if (!open || !data) return null;

    const detail = data.InvoiceDetails?.[0];

    return (
        <AnimatePresence>
            <motion.div
                className="invoice-detail-sheet mobile"
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ type: 'spring', stiffness: 280, damping: 30 }}
            >

                {/* Header */}
                <div className="sheet-header mobile">
                    <div className="title">
                        <ReceiptLongIcon />
                        <span>فاکتور #{data.ShomareFactor}</span>
                    </div>
                    <button className="back-btn" onClick={onClose}>
                        <ArrowBackIosNewIcon />
                    </button>
                </div>
                <div className="small-container">
                    {/* Content */}
                    <div className="sheet-content mobile">

                        {/* Hero Amount */}
                        <div className="hero-amount">
                            <span className="label">مبلغ قابل پرداخت</span>
                            <strong>
                                {formatPrice(data.MablaghGhabelePardakht)} ریال
                            </strong>
                        </div>

                        {/* Meta info */}
                        <div className="meta-list">
                            <div className="meta-row">
                                <CalendarTodayOutlinedIcon />
                                <span>تاریخ</span>
                                <strong>{data.TarikhFactor}</strong>
                            </div>

                            <div className="meta-row">
                                <Inventory2OutlinedIcon />
                                <span>تعداد کارتن</span>
                                <strong>{detail?.TedadeKartan}</strong>
                            </div>
                        </div>

                        <div className="divider" />

                        {/* Visitor */}
                        {detail && (
                            <div className="section">
                                <h6>ویزیتور</h6>

                                <div className="meta-row">
                                    <PersonOutlineIcon />
                                    <span>{detail.NameVizitor}</span>
                                </div>

                                <div className="meta-row">
                                    <PhoneOutlinedIcon />
                                    <span>{detail.TelefonVizitor}</span>
                                </div>
                            </div>
                        )}

                        <div className="divider" />

                        {/* Discounts */}
                        {detail && (
                            <div className="section">
                                <h6>تخفیف‌ها</h6>

                                <div className="meta-row">
                                    <PercentOutlinedIcon />
                                    <span>درصد تخفیف</span>
                                    <strong>{detail.DarsadTakhfifNagd}%</strong>
                                </div>

                                <div className="meta-row">
                                    <PaymentsOutlinedIcon />
                                    <span>مبلغ تخفیف نقدی</span>
                                    <strong>
                                        {formatPrice(detail.MablaghTakhfifNagdi)} ریال
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};

export default InvoiceDetailSheet;
